<template>
    <div class="point">
        <div class="point-bg"><img src="@img/misc/winning-point.png"/></div>
        <div class="point-text">{{ point }}</div>
    </div>
</template>

<script>
    export default {
        name: 'win-point',
        props: {
            point: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="less">
    @import "~@less/font-sizes.less";

    .point {
        @ballSize: 40px;

        margin-bottom: 20px;
        flex-wrap: nowrap !important;

        .point-bg {
            img {
                max-width: 60px;
            }
        }

        .point-text {
            padding-left: 10px;

            font-weight: bold;
            font-size: @app-font-size-win-point;

            align-self: center;
        }
    }
</style>